"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfSubmitDigestPreferencesDto = instanceOfSubmitDigestPreferencesDto;
exports.SubmitDigestPreferencesDtoFromJSON = SubmitDigestPreferencesDtoFromJSON;
exports.SubmitDigestPreferencesDtoFromJSONTyped = SubmitDigestPreferencesDtoFromJSONTyped;
exports.SubmitDigestPreferencesDtoToJSON = SubmitDigestPreferencesDtoToJSON;
exports.SubmitDigestPreferencesDtoToJSONTyped = SubmitDigestPreferencesDtoToJSONTyped;
/**
 * Check if a given object implements the SubmitDigestPreferencesDto interface.
 */
function instanceOfSubmitDigestPreferencesDto(value) {
    if (!('displayName' in value) || value['displayName'] === undefined)
        return false;
    if (!('selectedSports' in value) || value['selectedSports'] === undefined)
        return false;
    if (!('sportAnswers' in value) || value['sportAnswers'] === undefined)
        return false;
    if (!('digestTimeCode' in value) || value['digestTimeCode'] === undefined)
        return false;
    return true;
}
function SubmitDigestPreferencesDtoFromJSON(json) {
    return SubmitDigestPreferencesDtoFromJSONTyped(json, false);
}
function SubmitDigestPreferencesDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'sessionId': json['sessionId'] == null ? undefined : json['sessionId'],
        'displayName': json['displayName'],
        'selectedSports': json['selectedSports'],
        'sportAnswers': json['sportAnswers'],
        'streamingPlatforms': json['streamingPlatforms'] == null ? undefined : json['streamingPlatforms'],
        'digestTimeCode': json['digestTimeCode'],
        'championDigestTimeCode': json['championDigestTimeCode'] == null ? undefined : json['championDigestTimeCode'],
    };
}
function SubmitDigestPreferencesDtoToJSON(json) {
    return SubmitDigestPreferencesDtoToJSONTyped(json, false);
}
function SubmitDigestPreferencesDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'sessionId': value['sessionId'],
        'displayName': value['displayName'],
        'selectedSports': value['selectedSports'],
        'sportAnswers': value['sportAnswers'],
        'streamingPlatforms': value['streamingPlatforms'],
        'digestTimeCode': value['digestTimeCode'],
        'championDigestTimeCode': value['championDigestTimeCode'],
    };
}
